module.exports = __webpack_public_path__ + "assets/img/fr-646aa2be.png";